<template>
  <div class="page-content egl-dialog-elm original-dialog">
    <h1 class="page-title">{{ $locale("sideMenu.accounting.management") }}</h1>
    <!-- searchArea -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-input
              :placeholder="$locale('accounting.accountName')"
              v-model="curValue"
              @keyup.enter.native="search()"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="search()">{{$locale("global.search")}}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="ta-r">
        <el-button class="egl-btn-gray" disabled v-if="!unApprove">{{ $locale("global.approve") }}</el-button>
        <el-button class="egl-btn-yellow" @click="approve_fn" v-else>{{ $locale("global.approve") }}</el-button>
        <el-button @click="isDialogShow" class="egl-btn-yellow">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>
    <!-- table -->
    <div class="egl-table list-table">
      <el-table
        :data="tableData"
        stripe
        @filter-change="filterHandler"
        @sort-change="shorChange"
      >
        <el-table-column :label="$locale('global.change')" width="50" align="center">
          <template slot-scope="scope">
            <i class="el-icon-circle-check change" v-show="!scope.row.isApprove"></i>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, idx) in labelData"
          :key="idx"
          :label="item.label"
          :prop="item.prop"
          :align="item.align"
          :column-key="item.filterName && item.filterName"
          :filters="item.filters && item.filters"
          :sortable="item.sortable"
        />
        <el-table-column :label="$locale('global.control')" align="center" width="150">
          <template slot-scope="scope">
            <div class="handle">
              <a @click="isDialogShow('update', scope.row)"> {{ $locale("global.edit") }} </a>
              <el-divider direction="vertical"></el-divider>
              <a @click="approve_fn('delete', scope.row.name, scope.row.id, scope.row.brandDefault)">
                {{ $locale("global.delete") }}
              </a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CommPagination
      :total="count"
      :curPage="currentPage"
      @current-change="pageChange"
      :pageSize="20"
    />
    <!-- dialog -->
    <el-dialog
      :visible.sync="isDialogVisible"
      width="660px"
      @close="closeHandler"
      class="egl-dialog"
      ref="accountDialog"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <div class="tipsBox">
          <p>{{ $locale("accounting.accountsAddOrEdit") }}</p>
          <el-tooltip
            :content="$locale('accounting.accountsAddOrEdit')"
            placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>
      <div class="dialog-content">
          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("accounting.basicInfoRegSubjects") }}</div>
            <el-tooltip :content="$locale('accounting.basicInfoRegSubjects')" placement="top"
              ><span class="tipIcon"></span
            ></el-tooltip>
          </div>
          <el-form
            label-position="top"
            label-width="40px"
            :model="form"
            class="setForm"
            ref="accountForm"
            :rules="rules"
            :disabled="!isEdit"
          >
            <el-form-item :label="$locale('accounting.accountName')" prop="name">
              <el-input
                :placeholder="$locale('accounting.accountName.ex')"
                v-model="form.name"
              />
            </el-form-item>
            <el-form-item :label="$locale('accounting.accountCode')" prop="code">
              <el-input
                placeholder="001"
                v-model="form.code"
              />
            </el-form-item>
            <el-form-item :label="$locale('accounting.functionClassification')" prop="moneyType">
              <el-select
                :placeholder="$locale('accounting.plsSelectFunctionClassification')"
                v-model="form.moneyType"
              >
              <el-option v-for="i in accountingOpts"
                :label="accountingFunctionsMap[i]"
                :value="i"
                :key="i"></el-option>
                
                <!-- <el-option
                  :label="$locale('accounting.accountsPayable')"
                  value="buyMoney"
                  key="buyMoney"
                ></el-option>
                <el-option
                  :label="$locale('accounting.accountsReceivable')"
                  value="sellMoney"
                  key="sellMoney"
                ></el-option> -->
              </el-select>
            </el-form-item>
            <ApproveField v-if="!form.isApprove" v-model="form.reflectDate" :formData="form" fieldName="reflectDate" />
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex" justify="center">
            <el-col :span="10">
              <el-button
                @click="isDialogShow"
                class="egl-btn-white"
              >
                {{ $locale("global.cancel") }}
              </el-button>
            </el-col>
            <el-col :span="10">
              <el-button
                @click="submitForm('create')"
                class="egl-btn-yellow"
              >
                {{ $locale("global.confirm") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import {
  getAccountListService,
  addAccountService,
  updateAccountService,
  deleteAccountService,
  approveAccountService,
  AccountDetailService,
} from "@/helpers/service/api/accounting";
import ApproveField from "@/components/common/ApproveField";
import countDownAlert from "@/utils/countDownAlert";
// import { setFormHandler } from "@/utils/approve.js";
import { accountingFunctionsMap, accountingOpts } from "@/utils/common.js";
import CommPagination from "@/components/common/CommPagination";
// const brandId = window.localStorage.getItem("brandId");
// let brandId;

export default {
  data() {
    return {
      accountingOpts: accountingOpts,
      accountingFunctionsMap: accountingFunctionsMap,
      brandId: "",
      curValue: "",
      tableData: [],
      labelData: [
        {
          label: this.$locale("accounting.accountName"),
          prop: "name",
          width: 260
        },
        {
          label: this.$locale("accounting.accountCode"),
          prop: "code",
          sortable: "custom",
        },
        {
          label: this.$locale("accounting.functionClassification"),
          prop: "moneyTypeText",
          width: 150,
          filterName: "moneyType",
          filters: accountingOpts.map(value => ({
            text: accountingFunctionsMap[value],
            value
          }))
        },

        // {
        //   label: this.$locale("accounting.applicableAccountingRules"),
        //   prop: "accountingRules",
        //   width: 150,
        //   filterName: "accountingRules"
        // }
      ],
      isDialogVisible: false,
      moneyTypeName: {
        buyMoney: this.$locale("accounting.accountsPayable"),
        sellMoney: this.$locale("accounting.accountsReceivable"),
      },
      dialogType: "create",
      form: {
        name: "",
        moneyType: "",
        reflectDate: this.$moment().startOf("day").valueOf(),
      },
      isEdit: true,
      rules: {
        name: [
          { required: true, message: this.$locale("accounting.plsEnterAccountName"), trigger: "blur" }
        ],
        moneyType: [
          { required: true, message: this.$locale("accounting.plsSelectFunctionClassification"), trigger: "blur" }
        ]
      },
      count: 0,
      currentPage: 0,
      filterType: null,
      sorting: null,
    };
  },
  methods: {
    search() {
      this.currentPage = 0;
      this.getList();
    },
    getList() {
      getAccountListService({
        brandId: this.brandId,
        page: this.currentPage,
        pageSize: 20,
        ...(this.curValue ? { name: this.curValue } : {}),
        ...(this.filterType ? { moneyType: this.filterType } : {}),
        ...(this.sorting ? { sort: this.sorting } : {}),
      }).then(res => {
        this.count = res.data.count;
        let { data: { data } } = res;
        data.forEach(item => {
          item.moneyTypeText = this.accountingFunctionsMap[item.moneyType];
        });
        this.tableData = data;
      });
    },
    isDialogShow(type, data) {
      if (type === "update") {
        AccountDetailService({ id: data.id }).then(res => {
          this.form = res.data;
          this.isEdit = res.data.edit;
          this.isDialogVisible = !this.isDialogVisible;
          if (type === "update") {
            this.dialogType = "update";
          }
        });
      }else {
        this.isDialogVisible = !this.isDialogVisible;
      }
    },
    closeHandler() {
      this.dialogType = "create";
      this.form = {
        name: "",
        moneyType: "",
        reflectDate: this.$moment().startOf("day").valueOf(),
      };
    },
    submitForm() {
      this.$refs.accountForm.validate(valid => {
        if (valid) {
          const requestParam =  {
            ...this.form,
            brandId: window.localStorage.getItem("brandId"),
          };
          const requestSuccessFn = showText => {
            this.isDialogShow();
            countDownAlert({
              content: showText,
              callback: () => {
                this.getList();
              }
            });
          };

          if (this.dialogType === "create") {
            addAccountService(requestParam).then(() => {
              requestSuccessFn(this.$locale("global.createSuccessfully"));
            });
          } else {
            updateAccountService(requestParam).then(() => {
              requestSuccessFn(this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          return false;
        }
      });
    },
    showApprove() {
      this.$refs.approve.toggleApprove();
    },
    approve_fn(type, name, id, isDelete) {
      // let name = '';
      let confirmHtml = "";
      if (isDelete) {
        MessageBox.alert(this.$locale("global.cannotDelete"), {
          showClose: false,
        });
        return;
      }
      if (type === "delete") {
        confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}?</span>`;
      } else {
        confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;
      }
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          if (type === "delete") {
            deleteAccountService({ id }).then(() => {
              this.getList();
            });
          } else {
            approveAccountService({ brandId: this.brandId }).then(() => {
              this.getList();
            });
          }
        });
    },
    pageChange(value) {
      if (!value) { return; }
      this.currentPage = value - 1;
      this.getList();
    },
    filterHandler(filters) {
      this.filterType = filters.moneyType;
      this.getList();
    },
    shorChange({ prop, order }) {
      const _sortMapping = {
        ascending: "ASC",
        descending: "DESC",
      };

      if (prop === "code") {
        this.sorting = _sortMapping[order];
        this.getList();
      }
    },
  },
  computed: {
    unApprove() {
      return this.tableData.some(item => !item.isApprove);
    },
  },
  created() {
    // console.log('created')
    this.brandId = window.localStorage.getItem("brandId");
    this.getList();
  },
  components: {
    ApproveField,
    CommPagination,
  }
};
</script>
